import { userAppApiRequest } from './apiWrapper'
import { getDeviceId } from '../utils/helper'
import { getRecaptcha } from '../utils/localStorage'
import { API_END_POINT, API_METHOD } from '../utils/constants'
import { encryptPayload } from '../../../../apps/super-app/src/crypto/encryptPayload.js'

// API Client ID from the curl command
const API_CLIENT_ID = 'CZgbPYnmcj5iyEH9tg0GYvB4lm9gGQ9qs6jQwllV'
const APP_VERSION = window.version || '1.0.0'

export const getApiHeaders = ({ platform = 'web', countryCode = 'IN' } = {}) => {
  const deviceId = getDeviceId()
  return {
    'accept': 'application/json',
    'x-api-client': API_CLIENT_ID,
    'x-platform': platform,
    'x-country': countryCode,
    'x-app-version': APP_VERSION,
    'Content-Type': 'application/json',
    'x-device-id': deviceId
  }
}

export async function getDeviceInfo() {
  let deviceId = getDeviceId()
   if (!deviceId){
    deviceId = crypto.randomUUID();
   }

  const userAgent = navigator.userAgent || ''
  const isMobile = /Mobi|Android/i.test(userAgent)
  const isTablet = /Tablet|iPad/i.test(userAgent)

  let deviceType = 'desktop'
  if (isMobile) {
    deviceType = 'mobile'
  } else if (isTablet) {
    deviceType = 'tablet'
  }

  let deviceName = 'Web Browser'
  if (navigator.userAgentData?.platform) {
    deviceName = `${navigator.userAgentData.platform} Browser`
  } else if (userAgent.includes('Chrome')) {
    deviceName = 'Web Chrome'
  } else if (userAgent.includes('Firefox')) {
    deviceName = 'Web Firefox'
  } else if (userAgent.includes('Safari')) {
    deviceName = 'Web Safari'
  } else if (userAgent.includes('Edge')) {
    deviceName = 'Web Edge'
  }

  const getCountryCode = () => {
    const lang = navigator.language || navigator.userLanguage || 'en-US'
    const parts = lang.split('-')
    if (parts.length > 1) {
      return parts[1].toUpperCase()
    }
    return 'US'
  }

  const countryCode = getCountryCode()
  // Get push token from localStorage (set by Firebase messaging)
  const pushToken = localStorage.getItem('fcmToken') || ''
  // Get native token if available
  const nativeToken = localStorage.getItem('nativeToken') || ''

  let deviceIp = ''
  try {
    // Optionally, you could fetch IP from a service here
    // For now, leaving it empty as IP detection in browser requires external service
    deviceIp = sessionStorage.getItem('deviceIp') || ''
  } catch (error) {
    console.warn('Could not get device IP:', error)
  }

  const drmType = 'drm widevine'   // Default for web
  const platform = isMobile ? 'mweb' : 'web'

  const deviceData = {
    serial_number: deviceId,
    device_name: deviceName,
    device_type: deviceType,
    platform: platform,
    // push_token: pushToken,
    // device_ip: deviceIp,
    // is_vpn: false,                // Cannot detect VPN in browser without backend assistance
    // is_anonymous_proxy: false,    // Cannot detect in browser
    // residency_verified: false,
    // is_rooted: false,             // Not applicable for web
    // is_jailbroken: false,         // Not applicable for web
    device_active: true,
    drm_type: drmType,
    // hardware_encryption: false,
    // transaction_type: 'free',
    // is_ip_legal: true,            // Default to true
    // native_token: nativeToken
  }

  // Add country code for header usage
  deviceData._countryCode = countryCode
  return deviceData
}

export async function registerDeviceApi(deviceData) {
  try {
    const countryCode = deviceData._countryCode || 'IN'
    const platform = deviceData.platform || 'web'
    const cleanDeviceData = { ...deviceData }
    delete cleanDeviceData._countryCode
    //check the payload before encypt in macos
    console.log(cleanDeviceData,"cleanDeviceData")
    const encryptedData = await encryptPayload(cleanDeviceData)

    const headers = getApiHeaders({ platform, countryCode })

    const response = await userAppApiRequest({
      method: 'post',
      url: 'user/v1/device/device_registration',
      data: encryptedData,
      headers
    })
    
    if (response?.data?.device_id) {
      localStorage.setItem('deviceId', response.data.device_id)
    }

    return response.data
  } catch (error) {
    console.error('Device registration API error:', error)

    if (error?.response?.data) {
      if (typeof error.response.data === 'object') {
        throw new Error(error.response.data.detail || error.response.data.message || 'Device registration failed')
      }
      if (typeof error.response.data === 'string') {
        throw new Error(error.response.data)
      }
      throw new Error(JSON.stringify(error.response.data))
    }

    throw new Error(error.message || 'Device registration failed')
  }
}

export async function syncPushTokenApi(pushToken) {
  const { platform, _countryCode: countryCode } = await getDeviceInfo()
  const encryptedData = await encryptPayload({ push_token: pushToken })

  const headers = getApiHeaders({ platform, countryCode })
  const accessToken = localStorage.getItem('access')

  if (!accessToken || !headers['x-device-id']) {
    throw new Error('Push token sync needs a logged-in user and a registered device')
  }

  const response = await userAppApiRequest({
    method: API_METHOD.Post,
    url: API_END_POINT.syncPushToken,
    data: encryptedData,
    headers: {
      ...headers,
      'x-api-token': accessToken
    }
  })

  if (!response?.data?.redis_synced) {
    throw new Error(response?.message || 'Push token was not synced to the notification cache')
  }

  return response.data
}
